import { getJSON } from "../../shared_component/utils/fetch"
import { getApiBaseUrl } from "../../shared_component/utils/urlUtils"

const FUEL_STATION_BASE_URL = `${getApiBaseUrl()}/api/v6/fuel_card`
const FUEL_SITES = "/fuel_sites"

export function getFuelStations(payload) {
  return async function (dispatch, getState) {
    const user = getState().user || {}
    const { authentication_token } = user

    const request = {
      headers: { Authorization: authentication_token }
    }

    let url = `${FUEL_STATION_BASE_URL}${FUEL_SITES}?`

    if (payload) {
      Object.entries(payload).forEach(([key, value]) => {
        if (value) {
          url += `${encodeURIComponent(key)}=${encodeURIComponent(value)}&`
        }
      })
      // Remove the trailing "&"
      url = url.slice(0, -1)
    }

    const response = await getJSON(url, {}, request.headers)

    if (response.result) {
      return response
    } else {
      payload.callback && payload.callback("failure", { message: response.error })
    }
    return response
  }
}
